// // YYYY. MM. DD 형식으로 변환
// export const formatDate = (d) => {
//   if (!d) return "";
//   const [y, m, day] = d.split("-");
//   return `${y}. ${m}. ${day}`;
// };

// YYYY. MM. DD 형식으로 변환
export const formatDate = (d) => {
  if (!d) return "";

  const dateOnly = d.substring(0, 10);

  const [y, m, day] = dateOnly.split("-");
  return `${y}. ${m}. ${day}`;
};
